import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { aiAnalysisDialogStyles } from './styles';

export default function AIAnalysisDialog({
  open,
  onClose,
  title,
  titleColor = 'secondary.main',
  loading,
  error,
  children,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={aiAnalysisDialogStyles.title(titleColor)}>{title}</DialogTitle>

      <DialogContent dividers>
        {loading && (
          <Box sx={aiAnalysisDialogStyles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={aiAnalysisDialogStyles.errorAlert}>
            <Typography fontWeight="bold">AI Analysis Failed</Typography>
            <Typography variant="body2">{error}</Typography>
          </Alert>
        )}

        {children}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
